import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';

import { FunctionField, useRecordContext } from 'react-admin';
import get from 'lodash/get';

import {makeStyles} from '@material-ui/core/styles';
import { OrderFlags } from 'entities/OrderFlags';

export const useStyles = makeStyles({
	chip: {
        borderColor: props => props.borderColor || '#A6A6A6',
		width: '100%',
        borderWidth: 2,
		maxWidth: 69,
		fontSize: 12
	}
});

export const ObjectChipField = ({ object, titleKey="full_name", tooltipKey=null, borderColor=null, ...props }) => {
    const classes = useStyles({ borderColor });

    return (
        <FunctionField
            {...props}
            addLabel={true}
            render={record => {
                const value = get(record, props.source);
                if (value == null) return null;
                const data = object[value];
                if (!data) return null;
                if (tooltipKey) {
                    return (
                        <Tooltip title={data[tooltipKey]} placement="right">
                            <Chip
                                fontSize="small"
                                variant="outlined"
                                className={classes.chip}
                                size="small"
                                label={data[titleKey]}
                            />
                        </Tooltip>
                    );
                }
                return data[titleKey];
            }}
        />
    );
};

export const OrderServiceChipField = (props) => {
    const record = useRecordContext();
    if (!record) return null;

    const dynamicBorderColor = record.flags & OrderFlags.IS_SERVICE_CHANGED ? '#DE350B' : null;

    return (
        <ObjectChipField
            {...props}
            borderColor={dynamicBorderColor}
        />
    );
};


ObjectChipField.defaultProps = {
    addLabel: true,
};
